// extracted by mini-css-extract-plugin
export default {"imageLogo":"CompanyUserEntity_imageLogo__qPdN3","buttonSize":"CompanyUserEntity_buttonSize__n0Ske"};